export var version = {
  lib: '2.9659.2',
  product: '2.9659.2',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts